$( document ).ready(function() {
    	$('.store-page-slider').not('.slick-initialized').slick({
              slidesToShow: 2,
              slidesToScroll: 1,
  			  variableWidth: true,
              prevArrow: '<button type="button" class="slick-btn slick-prev"></button>',
              nextArrow: '<button type="button" class="slick-btn slick-next"></button>'
      	});
});



   		 
